export default __webpack_public_path__ + "static/media/pencil-edit-alt.5c3d7bbc.svg";